import { getLocalDb } from '../client'
import { STORES } from '../constants'

/** Baca satu nilai meta (string) atau null bila belum ada. */
export const getMeta = async (key) => {
  const db = await getLocalDb()
  const row = await db.get(STORES.META, key)
  return row ? row.value : null
}

export const setMeta = async (key, value) => {
  const db = await getLocalDb()
  await db.put(STORES.META, { key, value })
}

export const getMetaNumber = async (key) => {
  const value = await getMeta(key)
  if (value == null) {
    return null
  }
  const num = Number(value)
  return Number.isFinite(num) ? num : null
}
